import {
  TextField,
  UrlField,
  ToggleField,
  SelectField,
  NumberField,
  DateField,
} from '../models';

import { operationalStatusOpt } from '../../../../options';

const getProjectName = () => {
  switch (process.env.REACT_APP_FIREBASE_PROJECT_LABEL) {
    case 'legalone-analytics':
      return 'Analytics';
    case 'legalmetrics':
      return 'Metrics';
    default:
      return 'Benner-Metrics';
  }
};

const checkIsPlanPush = (state) => (state?.plan !== 'push');

const Contrato = [
  new TextField({
    kWord: 'name',
    label: 'Nome da empresa*',
    required: true,
  }),
  new UrlField({
    kWord: 'companyurl',
    label: 'Url da empresa',
  }),
  new SelectField({
    kWord: 'operationalStatus',
    label: 'Situação operacional',
    options: operationalStatusOpt,
  }),
  new TextField({
    kWord: 'external_identifier',
    label: 'Identificador externo',
  }),
  new NumberField({
    kWord: 'volumeData',
    label: 'Espaço em disco',
    min: 1,
  }),
  new NumberField({
    kWord: 'supers',
    label: 'Nº de proprietários',
    min: 1,
  }),
  new NumberField({
    kWord: 'scientists',
    label: 'Nº de cientistas',
    min: 0,
  }),
  new NumberField({
    kWord: 'guests',
    label: 'Nº de convidados',
    min: 0,
  }),
  new NumberField({
    kWord: 'snapshots',
    label: 'Nº de snapshots (stories)',
    min: 0,
  }),
  new ToggleField({
    kWord: 'scheduledSnapshotAllowed',
    label: 'Agendamento de snapshots (stories)',
  }),
  new NumberField({
    kWord: 'maxHistory',
    label: 'Nº de históricos de base',
    min: 0,
    default: 4,
  }),
  new ToggleField({
    kWord: 'scheduledHistoryAllowed',
    label: 'Agendamento de históricos de base',
  }),
  new ToggleField({
    kWord: 'publicLink',
    label: 'Permitir link público',
    default: true,
  }),
  new NumberField({
    kWord: 'publicLinkExpirationDays',
    label: 'Expiração link público (dias)',
    min: 0,
    default: 2,
  }),
  new ToggleField({
    kWord: 'publicLinkPwd',
    label: 'Senha para link público',
  }),
  new ToggleField({
    kWord: 'advancedCharts',
    label: 'Gráficos avançados',
  }),
  new ToggleField({
    kWord: 'externalKpis',
    label: 'KPI\'s externos',
  }),
  new NumberField({
    kWord: 'subsetTableLimit',
    label: 'Nº de subtabelas',
    min: 0,
    default: 1,
  }),
  new DateField({
    kWord: 'signatureDate',
    label: 'Data da assinatura',
  }),
  new DateField({
    kWord: 'operationalDate',
    label: 'Início da operação',
  }),
  new NumberField({
    kWord: 'projectValue',
    label: `Valor ${getProjectName()}`,
    min: 0,
    money: true,
    precision: 2,
    default: 359,
  }),
  new NumberField({
    kWord: 'installationPrice',
    label: 'Valor de implantação',
    min: 0,
    money: true,
    precision: 2,
    default: 359,
  }),
  new TextField({
    kWord: 'connectIntegration',
    label: 'Integração (connect)',
  }),
  new NumberField({
    kWord: 'reportAmount',
    label: 'Quantidade de relatórios',
    min: 0,
  }),
  new ToggleField({
    kWord: 'consulting',
    label: 'Consultoria',
    disabled: checkIsPlanPush,
  }),
  new NumberField({
    kWord: 'parameterizedDash',
    label: 'Dashboards parametrizados',
    min: 0,
    default: 2,
  }),
  new NumberField({
    kWord: 'customDash',
    label: 'Dashboards personalizados',
    min: 0,
    default: 2,
  }),
  new NumberField({
    kWord: 'attemptsPerHour',
    label: 'Tentativas de atualização de relatório por hora',
    min: 0,
    default: 3,
  }),
  new ToggleField({
    kWord: 'multifactor',
    label: 'Multifator obrigatório',
  }),
  new ToggleField({
    kWord: 'bigData',
    label: 'Acesso ao Big Data',
    removed: true,
  }),
  new ToggleField({
    kWord: 'l1reportActive',
    label: 'Permitir criação de relatório Legal One',
    removed: process.env.REACT_APP_FIREBASE_PROJECT_LABEL !== 'legalone-analytics',
  }),
  new ToggleField({
    kWord: 'gptApi',
    label: 'Assistente virtual',
    removed: process.env.REACT_APP_FIREBASE_PROJECT_LABEL === 'legalone-analytics',
  }),
];

export default Contrato;
